module.exports = __webpack_public_path__ + "static/img/PL.4379c88.png";


//////////////////
// WEBPACK FOOTER
// ./src/components/images/bouns/PL.png
// module id = cMoj
// module chunks = 1